


























import { Component, Mixins } from 'vue-property-decorator'
import axios from 'axios'
import moment from 'moment-timezone'
import SnackbarService from '@/services/snackbar-service'

@Component({
  components: {},
})
export default class RevisionsView extends Mixins(SnackbarService) {
  revisions: any[] = []

  search = ''

  headers = [
    { text: 'Fetcha', value: 'date' },
    { text: 'Finca', value: 'farm_id' },
    { text: 'Cantidad', value: 'count' },
    { text: 'Revisadas', value: 'revisioned' },
  ]

  created() {
    this.$store.state.loading = true
    this.$store.state.showAppbar = true
    this.$store.state.changeBack = '/home'
    this.$store.state.navbarText = 'Revisiones'
    axios
      .get(`/revisions`)
      .then((res: any) => {
        this.revisions = res.data
        this.revisions.forEach((revision: any) => {
          revision.datetime = moment.utc(revision.datetime).format('YYYY-MM-DD')
        })
      })
      .catch(error => {
        if (error.response && error.response.status >= 300) {
          this.notify({ text: `Server error. ${error}` })
        }
      })
      .finally(() => {
        this.$store.state.loading = false
      })
  }

  goToDetail(revision: any) {
    this.$store.state.showAppbar = true
    this.$store.state.changeBack = '/revisions'
    this.$store.state.navbarText = 'Revisiones'
    this.$router.push(`/revisions/${revision.farm_id}/${revision.date}`)
  }
}
